var _filter, _rect, _circle, _rect2, _path, _path2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "premiumGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10B981",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#14B8A6",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 100,
    height: 100,
    rx: 25,
    fill: "url(#premiumGradient)",
    filter: "url(#glow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 38,
    fill: "white",
    opacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 28,
    width: 6,
    height: 64,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 80 32 Q 60 38 58 48 Q 58 54 70 57",
    stroke: "white",
    strokeWidth: 5.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 80 57 Q 100 60 102 70 Q 102 76 80 80",
    stroke: "white",
    strokeWidth: 5.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.95
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 30)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 7,
    ry: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -2,
    cy: -1,
    r: 1.5,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: -1,
    r: 1.5,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 3 L -2 7 M 0 3 L 2 7",
    stroke: "#E31B23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 60)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -3,
    width: 36,
    height: 6,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -18,
    width: 6,
    height: 36,
    rx: 2,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.0a1c5a66c962fccf13c1fa73b7110969.svg";
export { ForwardRef as ReactComponent };